import type { BudgetItemTypeEnum } from "@src/__generated__/graphql";

export function encodeOiBudgetItemKey(
  outgoing_invoice_id: string,
  budget_item_id: string,
  budget_item_type: BudgetItemTypeEnum,
): string {
  return `${outgoing_invoice_id}::${budget_item_id}::${budget_item_type}`;
}

export function decodeOiBudgetItemKey(key: string): {
  outgoing_invoice_id: string;
  budget_item_id: string;
  budget_item_type: BudgetItemTypeEnum;
} {
  const [outgoing_invoice_id, budget_item_id, budget_item_type] =
    key.split("::");
  return {
    outgoing_invoice_id,
    budget_item_id,
    budget_item_type: budget_item_type as BudgetItemTypeEnum,
  };
}
